import React, { useEffect } from 'react';
import { Flex, Text } from "@chakra-ui/layout";
import { Badge, Grid, Image, Link } from "@chakra-ui/react";
import Doc from "../../../images/teacher/doc.svg";
import { useSelector } from 'react-redux';
import { useStudentAuthDispatch, StateType } from '../../../store/store';
import { getStudentNotes } from '../../../action/studentAction';

function StudentNotes() {
  const dispatch = useStudentAuthDispatch();
  const { data: { token }, notes: { notes } } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const studentToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));

  useEffect(() => {
    dispatch(getStudentNotes(studentToken));
  }, []);

  return (
    <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>notes</Text>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(200px, 250px))"} justifyContent={"center"}>
        {notes.length < 1 ? (
          <Text textTransform={"capitalize"} textAlign={"center"}>No Uploaded Notes</Text>
        ) : notes.map((note, index) => (
          <Flex key={index} bgColor={"brand.white"} flexDirection={"column"} m={4} borderRadius={"20px"} p={6}>
            <Text textTransform={"capitalize"} fontWeight={"extrabold"}
              fontSize={"lg"}>{note.course_name}</Text>
            <Text textTransform={"capitalize"} fontWeight={"extrabold"}
              fontSize={"sm"} mt={2}>{note.teacher_username}</Text>
            <Link href={note.file_link} download>
              <Image
                title={"document"}
                src={Doc}
                alt={"document icon"}
                boxSize={"30px"}
                mr={1}
                my={3}
                d={"inline-block"}
              />
              {note.file_name}
            </Link>
            <Badge bgColor={"black"} color={"white"} w={"90px"} p={1} borderRadius={"10px"} textAlign={"center"}>lesson 1</Badge>
          </Flex>
        ))}
      </Grid>
    </Flex>
  );
}

export default StudentNotes;